module.exports = __webpack_public_path__ + "data-table.b0aebd744ce7adb780a9.svg";


//////////////////
// WEBPACK FOOTER
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/assets/fonts/data-table/data-table.svg
// module id = ../../../../../src/assets/fonts/data-table/data-table.svg
// module chunks = 9